<template>
  <div class="p-4 sm:p-6 flex flex-col gap-6">
    <div class="rounded-lg overflow-hidden">
      <img
        src="https://lms-v3.s3.us-east-1.amazonaws.com/banner_default_brandonstevens.png"
        alt="Banner"
        class="w-full h-full object-cover"
        loading="lazy"
      />
    </div>

    <V4Summary />

    <div>
      <div class="flex gap-6 border-b border-untitled-gray-200 overflow-x-auto">
        <button
          v-for="tab in courseTabs"
          :key="tab.key"
          type="button"
          class="pb-3 text-sm font-medium whitespace-nowrap flex items-center gap-1.5 border-b-2 transition-colors"
          :class="
            activeTab === tab.key
              ? 'text-app-primary border-app-primary'
              : 'text-untitled-gray-500 border-transparent hover:text-untitled-gray-700'
          "
          @click="activeTab = tab.key"
        >
          {{ tab.label }}
          <span
            v-if="tab.badge"
            class="rounded-full bg-app-primary text-app-white text-[10px] font-semibold px-1.5 py-0.5"
          >
            {{ tab.badge }} New
          </span>
        </button>
      </div>

      <div class="my-5 mb-24">
        <component :is="display[activeTab]" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import V4Summary from "@/components/v4/home/summary/V4Summary.vue";
import { useHomeCoursesStore } from "@/stores/home/useHomeCourses.store";
import V4HomeCourseMain from "@/components/v4/home/courses/V4HomeCourseMain.vue";
import V4HomeLearningPathMain from "@/components/v4/home/learning-path/V4HomeLearningPathMain.vue";
import { useHomeLearningPathStore } from "@/stores/home/useHomeLearningPath.store";
import { watch } from "vue";
import V4MyVideosMain from "@/components/v4/home/my-videos/V4MyVideosMain.vue";
import V4HomeAssignedCourseMain from "@/components/v4/home/courses/V4HomeAssignedCourseMain.vue";
import V4AllAvailableContent from "@/components/v4/home/all-available-content/V4AllAvailableContent.vue";

const homeCoursesStore = useHomeCoursesStore();
const homeLearningPathStore = useHomeLearningPathStore();

const activeTab = ref("all");

const tabName = computed(() => homeCoursesStore.homeTab);

const courseTabs = computed(() => {
  return [
    { key: "all", label: tabName.value },
    { key: "learning-path", label: "My Learning Path & Playlists" },
    { key: "all-available-content", label: "All Available Content" },
    { key: "assigned", label: "Assigned Courses" },
    { key: "videos", label: "My Videos" },
  ];
});

const display = computed(() => {
  return {
    all: V4HomeCourseMain,
    "learning-path": V4HomeLearningPathMain,
    'all-available-content': V4AllAvailableContent,
    videos: V4MyVideosMain,
    assigned: V4HomeAssignedCourseMain,
  };
});

watch(activeTab, () => {
  homeCoursesStore.abortFetchCourses();
  homeLearningPathStore.abortFetchLearningPath();
});
</script>

<style scoped></style>
